import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments';

@Component({
  selector: 'wl-privacy-terms',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './privacy-terms.component.html',
  styleUrl: './privacy-terms.component.scss',
})
export class PrivacyTermsComponent {
  @Input() hideTrigger: boolean = false;

  /** Document displayed in the terms dialog. */
  @Input()
  get documentUrl(): string {
    return this._documentUrl;
  }

  set documentUrl(value: string) {
    this._documentUrl = value;
  }

  private _documentUrl: string = environment.neerPrivacyUrl;

  currentYear: number = new Date().getFullYear();

  open(): void {
    window.open(this.documentUrl, '_blank', 'noopener,noreferrer');
  }
}
